import { ArrowRight } from "lucide-react";
import { Eyebrow, SerifH } from "./shared";

export function Craftsmanship() {
  return (
    <section id="craftsmanship" data-testid="craftsmanship" className="bg-[#F4EDE2] text-[#0C111C]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-24 md:py-36 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <img
            src="/yaba_wear_for_prayer.jpg"
            alt="YABA atelier — Fes, Morocco"
            className="w-full h-auto rounded-sm"
          />
          <div className="absolute -bottom-6 -right-6 hidden md:block rounded-xl bg-[#0C111C] text-[#F4EDE2] px-5 py-4 shadow-2xl">
            <p
              className="text-[10px] tracking-[0.22em] uppercase text-[#C8A96A]"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              Fes, Morocco
            </p>
            <p className="mt-1 text-sm" style={{ fontFamily: "Fraunces, serif" }}>
              Since 2023
            </p>
          </div>
        </div>
        <div>
          <Eyebrow>Made in Fes, Morocco</Eyebrow>
          <SerifH className="mt-4" size="clamp(32px, 4vw, 64px)">
            Six generations of tailors.
            <br /> One obsession: the perfect drape.
          </SerifH>
          <p
            className="mt-6 max-w-md text-base md:text-lg text-[#3A3A3E]"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            Every YABA jellaba is cut and stitched by our partner atelier in the medina of Fes. From the raw viscose bolt to the final sfifa braid, every stage is done by hand — the way it has been done for over four hundred years.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            {[
              { n: "2023",  l: "Atelier partnered" },
              { n: "14",    l: "Artisans on the team" },
              { n: "18–22", l: "Hours per garment" },
            ].map((m) => (
              <div
                key={m.l}
                className="rounded-full border border-[#0C111C]/20 px-4 py-2 flex items-baseline gap-2"
              >
                <span className="text-[#C8A96A]" style={{ fontFamily: "Fraunces, serif" }}>
                  {m.n}
                </span>
                <span className="text-xs text-[#3A3A3E]" style={{ fontFamily: "Inter, sans-serif" }}>
                  {m.l}
                </span>
              </div>
            ))}
          </div>
          <a
            href="#about"
            data-testid="craftsmanship-cta"
            className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#0C111C] px-7 py-3.5 hover:bg-[#0C111C] hover:text-[#F4EDE2] transition-colors"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            Meet the atelier <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
